import { Attributes, ValueObject } from '@singularsystems/neo-core';

export class RicosConfig extends ValueObject {

    constructor() {
        super();
        this.makeObservable();
    }

    public fileNameQA: string = "QNGG00.XFERPK.SINGULAR.D0.SQ300";

    public fileNamePROD: string = "PNGG00.XFERPK.SINGULAR.D0.SQ300";

    // Client only properties / methods
}

export class PRNConfig extends ValueObject {

    constructor() {
        super();
        this.makeObservable();
    }

    public fileNameLiability: string = "PRN_Liability.txt";

    public fileNameAsset: string = "PRN_Asset.txt";;

    // Client only properties / methods
}

export class ExportConfig extends ValueObject {

    constructor() {
        super();
        this.makeObservable();
    }

    @Attributes.ChildObject(RicosConfig)
    public ricosConfig: RicosConfig | null = null;

    @Attributes.ChildObject(PRNConfig)
    public prnConfig: PRNConfig | null = null;

    // Client only properties / methods
}